import {ListItemIcon, ListItemText, Menu, MenuItem} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import {useI18n} from 'store/Store'

const NoteActions = ({anchorEl, handleClose, open, onDelete, onEdit, note}) => {
    const {i18n} = useI18n()
    const onClickEdit = () => {
        onEdit(note)
        handleClose()
    }

    const onClickDelete = () => {
        onDelete(note)
        handleClose()
    }

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            style={{direction: 'rtl'}}>
            <MenuItem onClick={onClickEdit}>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{i18n.t('form.edit')}</ListItemText>
            </MenuItem>
            <MenuItem onClick={onClickDelete}>
                <ListItemIcon>
                    <DeleteIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{i18n.t('form.delete')}</ListItemText>
            </MenuItem>
        </Menu>
    )
}

export default NoteActions
